import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ConnectorService } from '../connector.service';

export interface GameScoreEntry {
  id: string;
  username: string;
  score: number;
  createdAt: string;
}

@Injectable({ providedIn: 'root' })
export class GameScoreService {
  constructor(private http: HttpClient, private connector: ConnectorService) {}

  private headers() {
    return {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.connector.token(),
      },
    };
  }

  submitScore(gameId: string, score: number): Promise<any> {
    return this.http.post(
      environment.backAPI + '/game-scores',
      { gameId, score },
      this.headers()
    ).toPromise();
  }

  getTopScores(gameId: string, limit = 10): Promise<GameScoreEntry[]> {
    return this.http.get<GameScoreEntry[]>(
      environment.backAPI + '/game-scores/top?gameId=' + gameId + '&limit=' + limit,
      this.headers()
    ).toPromise() as Promise<GameScoreEntry[]>;
  }

  getMyScores(gameId: string, limit = 10): Promise<GameScoreEntry[]> {
    return this.http.get<GameScoreEntry[]>(
      environment.backAPI + '/game-scores/me?gameId=' + gameId + '&limit=' + limit,
      this.headers()
    ).toPromise() as Promise<GameScoreEntry[]>;
  }
}
